import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ComandosService } from '../../../infrastructure/services/comandos.service';
import { Observable } from 'rxjs/Observable';
import { ItemGeneralListado } from '../../../helpers/components/itemClasses/itemListadoGeneral.class';
import { RequestConfiguracionEndosoDTO } from '../../../infrastructure/services/importacionMasiva.service';

@Component({
  selector: 'sx-endoso-importacion-form',
  templateUrl: 'endoso.importacion.form.component.html'
})
export class EndosoImportacionFormComponent implements OnInit {
  private SERVICIO = 'SrvEndoso';
  comandoSeleccionado: String = null;

  request: RequestConfiguracionEndosoDTO = {
    comando: null,
    idPoliza: 0,
    idCertificado: 0,
  };

  comandos: Observable<ItemGeneralListado[]>;

  errores = {
    'comando': null,
    'idPoliza': null,
    'idCertificado': null,
  };

  constructor(private aRoute: ActivatedRoute,
              private comandosService: ComandosService,
              private router: Router) { }

  ngOnInit() {
    this.comandos = this.comandosService.getListadoComandosByCodServicioConTraduccion(this.SERVICIO);
  }

  seleccionarComando(comando: ItemGeneralListado) {
    this.request.comando = <string>comando.id;
  }

  validar() {
    this.errores = {
      'comando': null,
      'idPoliza': null,
      'idCertificado': null,
    };

    let esValido = true;
    if (!this.request.idPoliza) {
      this.errores.idPoliza = 'VALOR_REQUERIDO';
      esValido = false;
    }

    if (!this.request.idCertificado) {
      this.errores.idCertificado = 'VALOR_REQUERIDO';
      esValido = false;
    }

    if (!this.request.comando) {
      this.errores.comando = 'VALOR_REQUERIDO';
      esValido = false;
    }

    return esValido;
  }

  getFormData() {
    return this.request;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/importacionMasiva/forms/endoso.importacion.form.component.ts